package ru.villawonka.app.presentation.screens.setup.compose.layout

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.components.AppOutlinedButton
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary
import ru.villawonka.app.presentation.design.theme.surfaceLand
import ru.villawonka.app.presentation.screens.setup.compose.SetupCallbacks
import ru.villawonka.app.presentation.screens.setup.compose.view.StepperView
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupUIState
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_logo_140

@Composable
fun ColumnScope.SetupCurrencyStepLayout(
    state: SetupUIState.Step.Currency,
    callbacks: SetupCallbacks,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .background(
                color = MaterialTheme.colors.surfaceLand,
                shape = RoundedCornerShape(16.dp)
            )
            .fillMaxWidth()
            .padding(24.dp)
    ) {
        Image(
            painter = painterResource(Res.drawable.ic_logo_140),
            contentDescription = null,
            modifier = Modifier.size(81.dp)
        )
        AppSpacer(24.dp)
        Text(
            text = AppResources.strings.setupTitle,
            style = AppTextStyles.titleLargeBold,
            color = MaterialTheme.colors.onSurfacePrimary,
            textAlign = TextAlign.Center
        )
        AppSpacer(8.dp)
        Text(
            text = AppResources.strings.setupSubtitle,
            style = AppTextStyles.bodyMediumRegular,
            color = MaterialTheme.colors.onSurfaceSecondary,
            textAlign = TextAlign.Center
        )
        AppSpacer(24.dp)
        StepperView(
            currentStep = 3,
            stepCount = 3,
        )
    }
    AppSpacer(16.dp)
    Text(
        text = AppResources.strings.setupCurrencySelect,
        style = AppTextStyles.bodyMediumBold,
        color = MaterialTheme.colors.onSurfacePrimary,
        textAlign = TextAlign.Center
    )
    AppSpacer(16.dp)
    state.options.forEachIndexed { index, currency ->
        AppOutlinedButton(
            text = currency.string,
            icon = {
                Icon(
                    painter = painterResource(currency.icon),
                    contentDescription = null,
                )
            },
            type = AppButtonType.TERTIARY,
            size = AppButtonSize.LARGE,
            modifier = Modifier.fillMaxWidth(),
        ) {
            callbacks.onCurrencySelected(currency)
        }

        if (index != state.options.size - 1) {
            AppSpacer(16.dp)
        }
    }
}